module.exports = __webpack_public_path__ + "static/media/1682420542234-anand_headshot_02-2-2.e4a084a1.jpg";